// extracted by mini-css-extract-plugin
export var text = "_al-0";